import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en.json';
import ar from './locales/ar.json';

// Create a separate instance for Admin Portal to avoid conflicts with main app
const adminI18n = i18n.createInstance();

const resources = {
  en: { translation: en },
  ar: { translation: ar },
};

const LANGUAGE_KEY = 'admin-language'; // Independent language preference

const languageDetector = {
  type: 'languageDetector',
  async: true,
  detect: (callback) => {
    try {
      const stored = localStorage.getItem(LANGUAGE_KEY);
      if (stored) return callback(stored);
      return callback('ar'); // Default to Arabic
    } catch (e) {
      console.warn('admin i18n detect error', e);
      return callback('ar');
    }
  },
  init: () => {},
  cacheUserLanguage: (lng) => {
    try {
      localStorage.setItem(LANGUAGE_KEY, lng);
      // Update document direction
      document.dir = lng === 'ar' ? 'rtl' : 'ltr';
    } catch (e) {
      console.warn('admin i18n cache error', e);
    }
  },
};

adminI18n
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'ar',
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
  });

export default adminI18n;
